module.exports = __webpack_public_path__ + "img/de-product-classify_img_2.5ceffe88.jpg";